const defaultFilterValues = {
  contractActiveFrom: '',
  contractActiveTo: '',
  clientCategories: [],
  clientStatuses: [],
  clientName: '',
  axaptCode: '',
  registryNumber: '',
  pvnRegistryNumber: '',
  onlyMine: [],
  activeContract: [],
  manager: null,
  contractOrAgreementEndPeriod: '',
  contractIsCanceled: [],
  checkEndPeriodFor: [],
  hasContract: [],
  noContract: [],
  noActiveContract: [],
  reportSubCode: [],
  reportStatuses: [],
  reportPeriodFrom: '',
  reportPeriodTo: '',
  advancedFilters: false,
  exportCols: [],
  primary_filler_user_updated_at: '',
  disabled: [0],
  parentclient: ''
}

export default {
  name: 'ClientList',
  data () {
    return {
      isMounted: false,
      loading: false,
      tableData: [],
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      tableSorting: { item: 'name', direction: 'asc' },
      exportCols: null,
      currentReq: null,
      perPage: 10,
      currentPage: 1,
      rowCount: 0,
      pageCount: 0,
      objectId: null
    }
  },
  computed: {
    tableHeaders () {
      const actions = [{ label: this.$t('menu.clients.view'), emit: 'editClient', bicon: 'person-square' }];
      const headerConf = [
        { key: 'name', label: this.$t('client.name'), sortable: true, sortDirection: 'desc', filterKey: 'clientName' },
        { key: 'active_contracts', label: this.$t('client.section.contracts'), format: 'formatContractIcons', otherKey: 'materialGroupChanges' },
        { key: 'axaptCode', label: this.$t('client.axaptCode'), filterKey: 'axaptCode' },
        { key: 'registryNumber', label: this.$t('client.registryNumber'), filterKey: 'registryNumber' },
        { key: 'pvnRegistryNumber', label: this.$t('client.pvnRegistryNumber'), filterKey: 'pvnRegistryNumber' },
        { key: 'category_id', label: this.$t('client.category'), format: 'formatFromConfig', configKey: 'client_categories', configParam: 'name', sortable: true, filterKey: 'clientCategories' },
        { key: 'manager.name', label: this.$t('client.manager'), filterKey: 'manager' },
        { key: 'actions', label: '', actions: actions }
      ];
      return headerConf;
    },
    tableExpandConfig () {
      return { component: 'ClientListExpand' };
    },
    clientCategoryOptions () {
      const options = this.$store.getters.getConfigOptions('client_categories', this.$i18n.locale);
      options.unshift({ text: this.$t('general.filters.without'), code: 'NULL' });
      return options;
    },
    clientStatusOptions () {
      return [
        { code: 0, text: this.$t('client.status.active') },
        { code: 1, text: this.$t('client.status.blockedSystem') },
        { code: 2, text: this.$t('client.status.blockedAxapta') }
      ]
    },
    contractAgreementOptions () {
      return [
        { code: 0, text: this.$t('client.contract') },
        { code: 1, text: this.$t('client.contractAgreement') }
      ]
    },
    onlyMineOptions () {
      return [
        { code: 1, text: this.$t('client.onlyMine') }
      ];
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, 'disabled', 0);
    },
    managerOptions () {
      const options = this.$store.getters.getConfigOptions('managers');
      options.unshift({ text: this.$t(''), api_id: null });
      return options;
    },
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, true);
    },
    reportStatusOptions () {
      return this.$store.getters.getConfigOptions('client_report_statuses', this.$i18n.locale);
    },
    tableFilterConfig () {
      return {
        clientName: { type: 'text', label: this.$t('client.name'), colOnlyFilter: true },
        axaptCode: { type: 'text', label: this.$t('client.axaptCode'), colOnlyFilter: true },
        registryNumber: { type: 'text', label: this.$t('client.registryNumber'), colOnlyFilter: true },
        pvnRegistryNumber: { type: 'text', label: this.$t('client.registryNumber'), colOnlyFilter: true },
        onlyMine: { type: 'checkbox', label: ' ', options: this.onlyMineOptions, class: 'col-md-2' },
        clientCategories: { type: 'checkbox', label: this.$t('client.category'), options: this.clientCategoryOptions },
        clientStatuses: { type: 'checkbox', label: this.$t('client.status.title'), options: this.clientStatusOptions, class: 'col-md-2' },
        activeContract: { type: 'checkbox', label: this.$t('client.filters.activeContract'), options: this.materialGroupOptions },
        manager: { type: 'select', label: this.$t('client.manager'), options: this.managerOptions, valueField: 'api_id', colOnlyFilter: true },
        contractIsCanceled: { type: 'checkbox', label: this.$t('contract.isCanceled'), options: this.yesNoOptions, class: 'col-md-2' },
        contractOrAgreementEndPeriod: { type: 'date-period', label: this.$t('client.filters.contractOrAgreementEndPeriod') },
        disabled: { type: 'checkbox', label: this.$t('client.filters.disabled'), options: this.yesNoOptions, class: 'col-md-2' },
        checkEndPeriodFor: { type: 'checkbox', label: this.$t('client.filters.checkEndPeriodFor'), options: this.contractAgreementOptions, class: 'col-md-2' },
        parentclient: { type: 'text', label: this.$t('client.parent_client_id'), colOnlyFilter: false, class: 'col-md-2' },
        advancedFilters: {
          type: 'checkboxEnabler',
          label: this.$t('general.filters.advancedFilters'),
          class: 'col-sm-12',
          sub: {
            contractActiveFrom: { type: 'date-period', label: this.$t('client.filters.contractActiveFrom'), class: 'col-md-3' },
            contractActiveTo: { type: 'date-period', label: this.$t('client.filters.contractActiveTo'), class: 'col-md-3' },
            primary_filler_user_updated_at: { type: 'date', label: this.$t('client.filters.primary_filler_user_updated_at') },
            hasContract: { type: 'checkbox', label: this.$t('client.filters.hasContract'), options: this.materialGroupOptions },
            noContract: { type: 'checkbox', label: this.$t('client.filters.noContract'), options: this.materialGroupOptions },
            noActiveContract: { type: 'checkbox', label: this.$t('client.filters.noActiveContract'), options: this.materialGroupOptions },
            reportSubCode: { type: 'checkbox', label: this.$t('client.filters.reportSubCode'), options: this.reportNameOptions },
            reportStatuses: { type: 'checkbox', label: this.$t('client.filters.reportStatuses'), options: this.reportStatusOptions },
            reportPeriodFrom: { type: 'date-period', label: this.$t('client.filters.reportPeriodFrom'), class: 'col-md-2' },
            reportPeriodTo: { type: 'date-period', label: this.$t('client.filters.reportPeriodTo'), class: 'col-md-2' }
          }
        }
      };
    },
    filterActions () {
      const actions = { filters: false, reload: false, download: true };
      if (this.canEdit) {
        actions.add = { title: this.$t('menu.clients.new') }
      }
      return actions;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-clients');
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    }
  },
  methods: {
    getRequestPath (download = false) {
      let path = 'client/list';
      if (download) {
        path += '/1';
      }
      path += '?perPage=' + this.perPage + '&page=' + this.currentPage;
      if (this.tableSorting.item) {
        path += '&order=' + this.tableSorting.item + ',' + this.tableSorting.direction;
      }
      let filterVals = this.filterValues;
      if (this.$refs.tableview) {
        filterVals = this.$refs.tableview.getFilterValues();
      }
      this.BasicHelper.updateFilterValues(this.$route.name, filterVals);
      path = this.ApiRequest.addGetParamsToPath(path, filterVals, true);
      return path;
    },
    editClient (client, newtab) {
      let apiId = 'NEW';
      if (client) {
        apiId = client.api_id;
      }
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.edit', params: { clientApiId: apiId } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + apiId + '/edit');
      }
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      const self = this;
      this.loading = true;
      this.currentReq = this.ApiRequest.request(this.getRequestPath(), this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.tableData = response.data.table;
          const colConfig = [];
          response.data.columns.forEach(el => {
            colConfig.push({ key: el.key, name: self.$t('client.' + el.key), group: el.group });
          });
          self.exportCols = colConfig;
          self.loading = false;
        }
        if (response.paging) {
          self.rowCount = response.paging.total;
          self.currentPage = response.paging.page;
          self.pageCount = response.paging.pages;
        } else {
          self.pageCount = 0;
        }
      });
    },
    changePage (pageNr) {
      this.currentPage = pageNr;
      this.getTableData();
    },
    updateSort (item, desc) {
      this.tableSorting.item = item;
      if (desc) {
        this.tableSorting.direction = 'DESC';
      } else {
        this.tableSorting.direction = 'ASC';
      }
      this.getTableData();
    },
    reloadTable () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },
    clearFilters () {
      this.filterValues = this.BasicHelper.cloneObject(defaultFilterValues);
      this.reloadTable();
    },
    download (html, exportCols) {
      const self = this;
      self.$refs.tableview.setDownloading(1);
      const reqData = {};
      if (exportCols) {
        reqData.cols = exportCols;
      }
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.ApiRequest.request(this.getRequestPath(1), this.ApiRequest.REQUEST_DOWNLOAD, reqData, function () {
        self.$refs.tableview.setDownloading(0);
      });
    },
    getTableRowClass (item) {
      let res = '';
      if (item && (item.isBlocked || item.isAxBlocked)) {
        res += ' error';
      }
      if (item && item.disabled) {
        res += ' text-strikethrough';
      }
      return res;
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
  }
}
